import React, { memo } from "react";

const Loading = memo(() => {
  return <div>Loading</div>;
});

export default Loading;
